import Label from "lib/Label";
import React, { Fragment, useEffect,useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import "./index.scss";
import { setSubId } from "redux/userInfo";
import DynamicForm from "components/DynamicForm";
import { setStepperDisplay } from "redux/stepperReducer";
import { Image } from "lib";

import verification_badge from "assets/images/validation_checkmark.svg"
import field_validation_badge from "assets/images/field_validation_badge.svg"
import field_validation_badge_bw from "assets/images/field_validation_badge_bw.svg"
import field_validation_failed_badge from "assets/images/field_validation_failed_badge.svg"
import { OverlayTrigger, Popover } from "react-bootstrap";
import ToolTipV1 from "lib/TooltipV1";
import {  getDuplicateData } from "api/formDisplay";
import copyclipboard from "assets/images/copyclipboard.png";
import Toast from "components/ToastComponent";


const ViewCard = (props) => {
  const {
    title,
    form_field_items,
    input_fields,
    primaryUser: data,
    custom_styles,
    size,
    selectedData,
    setSelectedData,
    formErr,
    setFormErr,
    clearFieldError
  } = props;
 const verificationResult=selectedData?.verification_response
  const id = useSelector((state) => state?.urlEncryption?.urlId);
  const dispatch = useDispatch();
  
  const showPassword = `
  <svg enable-background="new 0 0 32 32" class="text-theme" stroke="currentColor" id="Editable-line" width="25" height="24" version="1.1" viewBox="0 0 32 32" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
	<path d="  M16,7C9.934,7,4.798,10.776,3,16c1.798,5.224,6.934,9,13,9s11.202-3.776,13-9C27.202,10.776,22.066,7,16,7z" fill="none" id="XMLID_13_"  stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" />
	<circle cx="16" cy="16" fill="none" id="XMLID_14_" r="3.5"  stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" />
	<line fill="none" id="XMLID_15_"  stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="3" x2="30" y1="5" y2="29" />
</svg>
  `
const hidePassword = `<svg id="look" class="text-theme" fill="currentColor" xmlns="http://www.w3.org/2000/svg"  width="20." height="15" viewBox="0 0 16.204 10.604">
<path id="Path_4093" data-name="Path 4093" d="M16.167,42.5q-.008-.021-.018-.042A8.928,8.928,0,0,0,.064,42.439a.562.562,0,0,0-.008.5,8.928,8.928,0,0,0,16.093,0A.563.563,0,0,0,16.167,42.5ZM8.1,46.878A7.852,7.852,0,0,1,1.191,42.7a7.805,7.805,0,0,1,13.823,0A7.853,7.853,0,0,1,8.1,46.878Z" transform="translate(-0.001 -37.397)"/>
<path id="Path_4094" data-name="Path 4094" d="M77.757,75.291a2.465,2.465,0,1,0,2.465,2.465A2.467,2.467,0,0,0,77.757,75.291Zm0,3.806A1.341,1.341,0,1,1,79.1,77.756,1.343,1.343,0,0,1,77.757,79.1Z" transform="translate(-69.655 -72.454)"/>
</svg>`;

  const sub_id = useSelector((state) => state.userInfo?.subId);
  const [duplicateData, setDuplicateData] = useState({}); 

  useEffect(() => {
    if (!sub_id && id?.userId) {
      dispatch(setSubId(id?.userId));
      dispatch(setStepperDisplay(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  //commenting this because we have used different approach this logic can be used in future this approach helps in showing the icon withount storing the key
  //below useeffect is used to check for the duplicate entry in the workflow and show tooltip displaying the content given in the config
  // useEffect(() => {
  //   const fetchDuplicates = async () => {
  //     if (!input_fields?.length) return;
  //     try {
  //       const primaryUser = { ...data, ...data?.source_data };
  //       const duplicatePromises = input_fields
  //         .filter((field) => field.name && primaryUser[field.name] && field?.content)
  //         .map(async (field) => {
  //           const payload = {
  //             organisation_id: primaryUser?.organisation_id,
  //             [`source_data.${field.name}`]: primaryUser[field.name],
  //           };
  //           const response = await getDuplicateData(payload);
  //           return response?.status === "Success" && response?.data?.length > 1
  //             ? { [field.name]: true }
  //             : null;
  //         });
  //       const results = await Promise.all(duplicatePromises);
  //       const updatedDuplicateData = results.reduce((acc, item) => {
  //         if (item) return { ...acc, ...item };
  //         return acc;
  //       }, {});
  
  //       setDuplicateData((prev) => ({ ...prev, ...updatedDuplicateData }));
  //     } catch (error) {
  //       console.error("Error fetching duplicate data:", error);
  //     }
  //   };
  
  //   fetchDuplicates();
  // }, [input_fields, data]);

 const [copiedToClipBoardSuccess, setCopiedToClipBoardSuccess] =
   useState(false);
  const handleCopyToClipboard = async (e) => {
    setCopiedToClipBoardSuccess(false);
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(selectedData?.payment_link || '');
      setCopiedToClipBoardSuccess(true);
      setTimeout(() => {
        setCopiedToClipBoardSuccess(false);
      }, 2000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
      setCopiedToClipBoardSuccess(false);
    }
  };
  
  


  const [maskType,setMaskType] = useState({})
  const togglePassword =(name)=>{
    if(maskType[name] == true)
    {
      let mask_type = {...maskType}
      mask_type[name] = false
      setMaskType(mask_type)
     return;
    }
    let mask_type = {...maskType}
    mask_type[name] = true
    setMaskType(mask_type)
  }
  const  maskedData = (data) =>{
    let masked_data =''
    for (const ch of data) {
      masked_data +='*'
    }
    return masked_data
  }

  const shouldShowField = (show) => {
    if (show) {
      return !!eval(show);
    }
    return true;
  };
  const renderTooltip = (props) => (
    <Popover id="tooltip-for-badges" style={{
      backgroundColor: "#4D4D4D",
      minHeight: "50px",
      textAlign: "center",
      paddingLeft: "10px",
      paddingRight: "10px",
    }}><div style={{textAlign:"center",color:"white",marginTop:"10px",fontWeight:"normal"}}>
      {props.message}
    </div>
    </Popover>
  );
  return (
    <>
      {title && title.length ? (
        <Label label={title} className="view_card_label" />
      ) : (
        ""
      )}
       {copiedToClipBoardSuccess && (
        <Toast
          // onClose = {()=>dispatch(resetAddedNewComment())}
          message="Copied to clipboard successfully!"
          type="success"
          autoClose={3000}
        />
      )}
         {input_fields &&
          input_fields?.length > 0 &&
        input_fields.map((item, index) => {
          
          const { label, label_class, name, size, show, shouldJoinArray, masking_type,doc_type,badges ,badge_field,content,show_duplicated_icon} =
          item;
          const primaryUser = {
        ...data,
              ...data?.source_data,
            };
            delete primaryUser?.source_data;
            let testData = ['1','2'];

            return (
              <Fragment key={index}>
                {item?.type ? (
                  <Fragment>
                    <DynamicForm
                      formFields={item}
                      selectedData={selectedData}
                      primaryUser={primaryUser}
                      setSelectedData ={setSelectedData}
                      formErr={formErr}
                      setFormErr={setFormErr}
                      clearFieldError={clearFieldError}
                    />

                  </Fragment>
                ) : (
                  <Fragment>
                    {shouldShowField(show) &&
                    (typeof primaryUser?.[name] === "string" ||
                      typeof primaryUser?.[name] === "number" ||
                      (typeof primaryUser?.[name] === "object" &&
                        shouldJoinArray)) ? (
                      <div className={`${size}`}>
                      <div className="position-relative ps-2">
                      <div className="d-flex  justify-content-between" >
                          <div className="d-flex align-items-center ">
                          <Label label={label} className="text-muted mb-0" />
                          
                         {/* {content && duplicateData && Object.entries(duplicateData).some(([key, value]) => key === name) ? (
                              <span className=""> 
                                <ToolTipV1
                                  type="warning"
                                  trigger="!"
                                  triggerWhen={["hover", "focus"]}
                                  selectedData={selectedData}
                                  tooltipText={
                                    <div className="d-flex flex-column">
                                      <p className="preview_data_value">{content}</p>
                                    </div>
                                  }
                                />
                              </span> 
                              ) : null } */}

                            {/* Here we are storing the key true is number is duplicated in database based on that key we are showing the icon */}
                              {content && primaryUser[show_duplicated_icon] && (
                               <span className=""> 
                                 <ToolTipV1
                                  type="warning"
                                   trigger="!"
                                   triggerWhen={["hover", "focus"]}
                                   selectedData={selectedData}
                                   tooltipText={
                                     <div className="d-flex flex-column">
                                    <p className="preview_data_value">{content}</p>
                                   </div>
                                 }
                                />
                              </span>
                            ) }
                          
                          </div>
                          <span>
                          {verificationResult?.[`${item.doc_type}`]?.is_verify &&item?.show_verified_icon && (
                              <div className="verified_badge p-1 bg-verified br-bottom-left-5px br-top-right-5px position-absolute top-0 end-0">
                               <p className="text-white mb-0 text-center fst-italic fw-bold fs-12px pe-1"> {item?.verification_message}</p>
                              </div>
                            )}
                          </span>
                              </div>
                              
                        <div className="d-flex align-items-center">
                        <p className={`mb-0 fw-bold fs-14px break-work-when-exceeds ${(maskType[name] === true || !maskType.hasOwnProperty(name)) ? 'mt-2' : 'mt-1'}`}>
                          {shouldJoinArray &&
                          Array.isArray(primaryUser?.[name]) &&
                          primaryUser?.[name]?.length > 0
                            ? primaryUser?.[name]
                                .map((item) => {
                                  if (item?.label || item?.value) {
                                    return item?.label || item?.value;
                                  }
                                  return item;
                                })
                                ?.join(", ")
                            : (maskType[name] == true || !maskType.hasOwnProperty(name)) && masking_type ? maskedData( primaryUser?.[name]) : primaryUser?.[name]}
                                </p>
                                {badges && (verificationResult?.[badge_field]?.hasOwnProperty("is_verify") ||selectedData?.documents?.[badge_field]) ? <OverlayTrigger
      placement="bottom-end"
      delay={{ show: 50, hide: 400 }}
      overlay={renderTooltip({message: verificationResult?.[badge_field]?.hasOwnProperty("is_verify") ? verificationResult?.[badge_field]?.is_verify === true ? selectedData?.documents?.[badge_field] ? "Verified and Validated" : "Verified" : "Verification Failed" : "Validated" })}
                                  
                                >
                                  <div style={{display:"flex"}}>
                                    {(selectedData?.documents?.[badge_field]) ?  <div className="veriifcationBadgeNonUploadField"> <Image className='image_style' imageSrc={(field_validation_badge)} /></div> : null}
                                    {verificationResult?.[badge_field]?.hasOwnProperty("is_verify") ? verificationResult?.[badge_field]?.is_verify === false ? <div className="veriifcationBadgeNonUploadField"> <Image className='image_style' imageSrc={(field_validation_failed_badge)} /> </div> : <div className="veriifcationBadgeNonUploadField"><Image className='image_style' imageSrc={(field_validation_badge)} /> </div>:null}
                                    </div>
    </OverlayTrigger>: null}
                                
                        {/* {
                           masking_type ? <Ima  ge className = 'img_container ms-3 z-index-0 cursor-pointer' imageSrc={(maskType[name] == true || !maskType.hasOwnProperty(name)) ? hide_password : show_password}  onClick={(e)=>togglePassword(name)}/> : null
                        } */}
                      {
                        masking_type ? (
                          <span className="d-flex align-items-center justify-content-center cursor-pointer mx-2 min-w-30px" dangerouslySetInnerHTML={{
                            __html: (maskType[name] === true || !maskType.hasOwnProperty(name)) ? hidePassword : showPassword
                          }} onClick={(e)=>togglePassword(name)}></span>
                        ):null
                      }
                   
                            </div>
                      </div>
                            {item?.number_verification_required && (
                              <div className="verified_badge">
                                <Image className='image_style' imageSrc={(verification_badge)} />                              
                                {item?.verification_message}
                              </div>
                            )}
                            {item?.copy && (
                              <span onClick={handleCopyToClipboard} id="copy_clipboard">
                                <Image
                                  imageSrc={copyclipboard}
                                  className="copy_to_clipboard"
                                />
                              </span>
                            )}
                          </div>
                      ) : null}

                  </Fragment>
                )}
              </Fragment>
            );
          })}
    </>
  );
};

export default ViewCard;
